const roundToTwo = (num) => (!num || Number.isNaN(num) ? 0 : num.toFixed(2));

export default roundToTwo;
